import { FormItemName } from '@src/framework/workbench/drawer/constants';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { BorderType, IBorderInfo } from '@src/slide/domain/ui-model/element-modeles/property/border/border.interface';
import {
    FillType, GradientType,
} from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { FONT_BORDER_KEY, FONT_FILL_KEY } from '@src/slide/domain/ui-model/element-modeles/property/text/constants';
import { TextDirectionType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';
import { IItems } from '../form.interface';

/**
 * 文字专项。文字设置专项需要隐藏的设置项。
 * @param model 所选元素
 * @returns
 */
export const getFontHideItems = (model: IElementBaseModel | IMultiplyModel): IItems => {
    const toolbarMenuValues = getAppService().editableServiceLayer?.menuManager.toolbarMenu().values ?? {};
    const fontFillInfo = toolbarMenuValues?.[FONT_FILL_KEY] || {};
    const fontBorderInfo = toolbarMenuValues?.[FONT_BORDER_KEY] || {};
    const fontFillType = Object.keys(fontFillInfo).find(key => !!fontFillInfo[key]) as FillType;
    const fontBorderType = getFontBorderType(fontBorderInfo);
    const fontGradBorderPath = fontBorderInfo?.gradFill?.pathGradient?.path;
    return {
        [FormItemName.FONT_SOLID_FILL_COLOR]: () => fontFillType !== FillType.SolidFill,
        [FormItemName.FONT_SOLID_FILL_COLOR_TEXT]: () => fontFillType !== FillType.SolidFill,
        [FormItemName.FONT_SOLID_FILL_OPACITY]: () => fontFillType !== FillType.SolidFill,
        [FormItemName.FONT_GRADUAL_FILL_LINEAR_GRADIENT]: () => fontFillType !== FillType.GradualFill,
        [FormItemName.FONT_GRADUAL_FILL_RADIAL_GRADIENT]: () => fontFillType !== FillType.GradualFill,
        [FormItemName.FONT_GRADUAL_FILL_RECT_GRADIENT]: () => fontFillType !== FillType.GradualFill,
        [FormItemName.FONT_GRADUAL_FILL_SHAPE_GRADIENT]: () => fontFillType !== FillType.GradualFill,
        [FormItemName.FONT_GRADUAL_FILL_ANGLE]: () => fontFillType !== FillType.GradualFill,
        [FormItemName.FONT_GRADUAL_FILL_DIRECTION]: () => fontFillType !== FillType.GradualFill,
        [FormItemName.FONT_GRADUAL_FILL_ANGLE_TEXT]: () => fontFillType !== FillType.GradualFill,
        [FormItemName.FONT_GRADUAL_FILL_DIRECTION_TEXT]: () => fontFillType !== FillType.GradualFill,
        [FormItemName.FONT_GRADUAL_FILL_TYPE_TEXT]: () => fontFillType !== FillType.GradualFill,
        [FormItemName.FONT_GRADUAL_FILL_BAR]: () => fontFillType !== FillType.GradualFill,
        [FormItemName.FONT_GRADUAL_FILL_OPACITY]: () => fontFillType !== FillType.GradualFill,
        [FormItemName.FONT_IMAGE_FILL_UPLOAD]: () => fontFillType !== FillType.ImageFill,
        [FormItemName.FONT_IMAGE_FILL_CLIPBOARD]: () => fontFillType !== FillType.ImageFill,
        [FormItemName.FONT_IMAGE_FILL_STYLE]: () => fontFillType !== FillType.ImageFill,
        [FormItemName.FONT_IMAGE_FILL_OPACITY]: () => fontFillType !== FillType.ImageFill,
        [FormItemName.FONT_BORDER_WIDTH]: () => fontBorderType !== BorderType.SolidFill,
        [FormItemName.FONT_BORDER_COLOR]: () => fontBorderType !== BorderType.SolidFill,
        [FormItemName.FONT_BORDER_COLOR_TEXT]: () => fontBorderType !== BorderType.SolidFill,
        [FormItemName.FONT_BORDER_OPACITY]: () => fontBorderType !== BorderType.SolidFill,
        [FormItemName.FONT_BORDER_WIDTH]: () => fontBorderType !== BorderType.SolidFill
            && fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_WIDTH_TEXT]: () => fontBorderType !== BorderType.SolidFill
            && fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_LINE]: () => fontBorderType !== BorderType.SolidFill
            && fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_LINE_TEXT]: () => fontBorderType !== BorderType.SolidFill
            && fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_SPACE]: () => fontBorderType !== BorderType.SolidFill,
        [FormItemName.FONT_BORDER_GRADUAL_LINEAR_GRADIENT]: () => fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_GRADUAL_RADIAL_GRADIENT]: () => fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_GRADUAL_RECT_GRADIENT]: () => fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_GRADUAL_SHAPE_GRADIENT]: () => fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_GRADUAL_ANGLE]: () => fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_GRADUAL_DIRECTION]: () => fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_GRADUAL_TYPE_TEXT]: () => fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_GRADUAL_ANGLE_TEXT]: () => fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_GRADUAL_DIRECTION_TEXT]: () => fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_GRADUAL_BAR]: () => fontBorderType !== BorderType.GradualFill,
        [FormItemName.FONT_BORDER_GRADUAL_OPACITY]: () => fontBorderType !== BorderType.GradualFill,
        [FormItemName.ORDER_OF_LINE_LABEL]: () => !isWordArtVertical(),
        [FormItemName.ORDER_OF_LINE]: () => !isWordArtVertical(),
    };
};

const getFontBorderType = (fontInfo: IBorderInfo): BorderType | undefined => {
    if (fontInfo?.gradFill) {
        return BorderType.GradualFill;
    }
    if (fontInfo?.color) {
        return BorderType.SolidFill;
    }
    if (fontInfo?.noFill) {
        return BorderType.NoFill;
    }
};

/**
* 是否是堆积排版
* @returns
*/
const isWordArtVertical = () => {
    const toolbarMenuValues = getAppService().editableServiceLayer?.menuManager.toolbarMenu().values ?? {};
    const textDirection = toolbarMenuValues?.[FormItemName.TEXT_DIRECTION];
    return textDirection === TextDirectionType.WORD_ART_VERTICAL_LTR
         || textDirection === TextDirectionType.WORD_ART_VERTICAL_RTL;
};

const getAppService = (): IPcEditorAppServices => AppServiceProvider.getInstance()
    .getAppServices() as IPcEditorAppServices;
